import * as React from 'react';

interface CollapsibleContextValue {
  open: boolean;
  toggle: () => void;
}

const CollapsibleContext = React.createContext<CollapsibleContextValue>({
  open: false,
  toggle: () => {},
});

interface CollapsibleProps {
  defaultOpen?: boolean;
  children: React.ReactNode;
}

function Collapsible({ defaultOpen = false, children }: CollapsibleProps) {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <CollapsibleContext.Provider value={{ open, toggle: () => setOpen((v) => !v) }}>
      <div data-state={open ? 'open' : 'closed'}>{children}</div>
    </CollapsibleContext.Provider>
  );
}

function CollapsibleTrigger({
  children,
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const { toggle, open } = React.useContext(CollapsibleContext);
  return (
    <button
      type="button"
      data-state={open ? 'open' : 'closed'}
      onClick={toggle}
      className={className}
      {...props}
    >
      {children}
    </button>
  );
}

function CollapsibleContent({ children }: { children: React.ReactNode }) {
  const { open } = React.useContext(CollapsibleContext);
  if (!open) return null;
  return <>{children}</>;
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
